/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
type AggregatesListingsFilters_root$ref = any;
type AggregatesListings_page$ref = any;
type AggregatesListings_root$ref = any;
type Layout_pageWithData$ref = any;
type Layout_root$ref = any;
type TopFilters_page$ref = any;
type TopFilters_root$ref = any;
type aggregatesListingDialogClient_aggregatesListings$ref = any;
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type LangInput = "de" | "en" | "es" | "fr" | "it";
export type OfferType = "buy" | "rent";
export type PropertyMainType = "AGRI" | "APPT" | "BUILDING" | "COMMERCIAL" | "GARDEN" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "INDUS" | "OTHER" | "PARK" | "PROP" | "ROOM" | "SECONDARY";
export type TypeOfPlace = "agglomeration" | "country" | "district" | "locality" | "municipality" | "neighbourhood" | "postcode" | "region" | "state";
export type AggregatesListingFiltersInput = {|
  bounds?: ?InputGeoBounds,
  placesById?: ?$ReadOnlyArray<?PlaceInput>,
  placeSlugs?: ?$ReadOnlyArray<?PlaceSlugInput>,
  offerType_eq: OfferType,
  createdAt_gte?: ?string,
  salePrice_lte?: ?number,
  salePrice_gte?: ?number,
  grossRentMonthly_lte?: ?number,
  grossRentMonthly_gte?: ?number,
  grossRentM2yearly_lte?: ?number,
  grossRentM2yearly_gte?: ?number,
  grossRentRoomMonthly_lte?: ?number,
  grossRentRoomMonthly_gte?: ?number,
  salePricePerLivingSurface_lte?: ?number,
  salePricePerLivingSurface_gte?: ?number,
  salePricePerLandSurface_lte?: ?number,
  salePricePerLandSurface_gte?: ?number,
  numberOfRooms_lte?: ?number,
  numberOfRooms_gte?: ?number,
  livingSurface_lte?: ?number,
  livingSurface_gte?: ?number,
  landSurface_lte?: ?number,
  landSurface_gte?: ?number,
  compositePropertyType_eq?: ?CompositePropertyType,
  portal_in?: ?$ReadOnlyArray<?string>,
  agencyReference_contains?: ?string,
  agencyNames?: ?string,
  hasBalcony_eq?: ?boolean,
  hasGarden_eq?: ?boolean,
  hasParking_eq?: ?boolean,
  hasElevator_eq?: ?boolean,
  hasView_eq?: ?boolean,
  hasFireplace_eq?: ?boolean,
  hasGarage_eq?: ?boolean,
  isChildFriendly_eq?: ?boolean,
  isWheelchairAccessible_eq?: ?boolean,
  isMinergieCertified_eq?: ?boolean,
  isNewDevelopment_eq?: ?boolean,
  isFurnished_eq?: ?boolean,
  bookOnline_eq?: ?boolean,
  isFsbo_eq?: ?boolean,
  clusterIds_contains?: ?number,
  id_eq?: ?string,
  id_in?: ?$ReadOnlyArray<string>,
|};
export type InputGeoBounds = {|
  north: number,
  south: number,
  east: number,
  west: number,
|};
export type PlaceInput = {|
  type: TypeOfPlace,
  objectId: string,
|};
export type PlaceSlugInput = {|
  lang: LangInput,
  slug: string,
|};
export type AggregatesListingFiltersPage = {|
  number: number,
  count: number,
|};
export type listingsQueryVariables = {|
  sortBy?: ?string,
  sortDirection?: ?string,
  filters: AggregatesListingFiltersInput,
  page?: ?AggregatesListingFiltersPage,
  slug: string,
  includePlace: boolean,
  includeCountry: boolean,
  uid: string,
  lang: string,
  lngShort: LangInput,
  propertyMainType?: ?PropertyMainType,
  numberOfRooms?: ?number,
  offerType: string,
  includeEn: boolean,
  includeFr: boolean,
  includeDe: boolean,
  includeIt: boolean,
  includeEs: boolean,
|};
export type listingsQueryResponse = {|
  +aggregatesListings: ?{|
    +totalCount: number,
    +filters: {|
      +places: ?$ReadOnlyArray<{|
        +countryCode: string,
        +type: TypeOfPlace,
        +slug: string,
        +slugEn?: string,
        +slugFr?: string,
        +slugDe?: string,
        +slugIt?: string,
        +slugEs?: string,
      |}>
    |},
    +$fragmentRefs: aggregatesListingDialogClient_aggregatesListings$ref,
  |},
  +placeBySlug?: ?{|
    +hasCanonical: boolean,
    +canonicalPlace: ?{|
      +slug: string,
      +lang: LangInput,
    |},
    +index: boolean,
  |},
  +cms: {|
    +pageWithData: ?{|
      +page: {|
        +$fragmentRefs: TopFilters_page$ref & AggregatesListings_page$ref
      |},
      +$fragmentRefs: Layout_pageWithData$ref,
    |},
    +navigation: ?{|
      +nav_listings_buy_logo_link: ?{|
        +template?: ?string,
        +_meta?: {|
          +uid: ?string
        |},
      |},
      +nav_listings_rent_logo_link: ?{|
        +template?: ?string,
        +_meta?: {|
          +uid: ?string
        |},
      |},
    |},
  |},
  +$fragmentRefs: Layout_root$ref & AggregatesListings_root$ref & AggregatesListingsFilters_root$ref & TopFilters_root$ref,
|};
export type listingsQuery = {|
  variables: listingsQueryVariables,
  response: listingsQueryResponse,
|};
*/


/*
query listingsQuery(
  $sortBy: String
  $sortDirection: String
  $filters: AggregatesListingFiltersInput!
  $page: AggregatesListingFiltersPage
  $slug: String!
  $includePlace: Boolean!
  $includeCountry: Boolean!
  $uid: String!
  $lang: String!
  $lngShort: LangInput!
  $propertyMainType: PropertyMainType
  $numberOfRooms: Float
  $offerType: String!
  $includeEn: Boolean!
  $includeFr: Boolean!
  $includeDe: Boolean!
  $includeIt: Boolean!
  $includeEs: Boolean!
) {
  ...Layout_root_3iqx2P
  ...AggregatesListings_root
  ...AggregatesListingsFilters_root
  ...TopFilters_root
  aggregatesListings(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, filters: $filters) {
    ...aggregatesListingDialogClient_aggregatesListings
    totalCount
    filters {
      places {
        countryCode
        type
        slug
        slugEn: slug(lang: en) @include(if: $includeEn)
        slugFr: slug(lang: fr) @include(if: $includeFr)
        slugDe: slug(lang: de) @include(if: $includeDe)
        slugIt: slug(lang: it) @include(if: $includeIt)
        slugEs: slug(lang: es) @include(if: $includeEs)
        id
      }
    }
  }
  placeBySlug(slug: $slug, lang: $lngShort) @include(if: $includePlace) {
    hasCanonical
    canonicalPlace {
      slug
      lang
      id
    }
    index
    id
  }
  cms {
    pageWithData(uid: $uid, lang: $lang) {
      page {
        ...TopFilters_page
        ...AggregatesListings_page
      }
      ...Layout_pageWithData
    }
    navigation(uid: "main", lang: $lang) {
      nav_listings_buy_logo_link {
        __typename
        ... on CMSPage {
          template
          _meta {
            uid
          }
        }
      }
      nav_listings_rent_logo_link {
        __typename
        ... on CMSPage {
          template
          _meta {
            uid
          }
        }
      }
    }
  }
}

fragment AggregatesListingCard_listing on AggregatesListing {
  ...useListingStructuredData_listing
  id
  slug
  encodedId
  offerType
  shortDescription: description(sentences: 3)
  shortTranslatedDescription: translatedDescription(sentences: 3)
  bulletPoints
  propertyType
  numberOfRooms
  livingSurface
  isFavourite
  usableSurface
  landSurface
  salePrice
  grossRentMonthly
  grossRentM2yearly
  currency
  postcode
  subLocality
  route
  streetNumber
  images(first: 100) {
    bucketName
    fileName
    blurhash
    id
  }
  url {
    url
    originalDomain
    originalUrl
    mergedListingId
  }
  translatedTitle
  salePricePerLivingSurface
  salePricePerLandSurface
  createdAt
  propertyMainType
  compositePropertyType
  visitContactPerson
  agencyName
  agencyReference
  lotReference
  constructionYear
  locality
  stateObject {
    label
    id
  }
  municipalityObject {
    label
    id
  }
  lat
  lng
  address
  numberOfBathrooms
}

fragment AggregatesListingCard_listing_VTAHT on AggregatesListing {
  ...useListingStructuredData_listing
  id
  slug
  encodedId
  offerType
  shortDescription: description(sentences: 3)
  shortTranslatedDescription: translatedDescription(sentences: 3)
  bulletPoints
  propertyType
  numberOfRooms
  livingSurface
  isFavourite
  usableSurface
  landSurface
  salePrice
  grossRentMonthly
  grossRentM2yearly
  currency
  postcode
  subLocality
  route
  streetNumber
  images(first: 100) {
    bucketName
    fileName
    blurhash
    id
  }
  url(filters: $filters) {
    url
    originalDomain
    originalUrl
    mergedListingId
  }
  translatedTitle
  salePricePerLivingSurface
  salePricePerLandSurface
  createdAt
  propertyMainType
  compositePropertyType
  visitContactPerson
  agencyName
  agencyReference
  lotReference
  constructionYear
  locality
  stateObject {
    label
    id
  }
  municipalityObject {
    label
    id
  }
  lat
  lng
  address
  numberOfBathrooms
}

fragment AggregatesListing_aggregatesListings on AggregatesListingConnectionConnection {
  ...aggregatesListingAlertDialog_aggregatesListings
}

fragment AggregatesListingsAnalytics_aggregatesListings on AggregatesListingConnectionConnection {
  filters {
    offerType_eq
    salePrice_lte
    salePrice_gte
    createdAt_gte
    grossRentMonthly_lte
    grossRentMonthly_gte
    grossRentM2yearly_lte
    grossRentM2yearly_gte
    grossRentRoomMonthly_lte
    grossRentRoomMonthly_gte
    salePricePerLivingSurface_lte
    salePricePerLivingSurface_gte
    salePricePerLandSurface_lte
    salePricePerLandSurface_gte
    numberOfRooms_lte
    numberOfRooms_gte
    livingSurface_lte
    livingSurface_gte
    landSurface_lte
    landSurface_gte
    compositePropertyType_eq
    portal_in
    agencyReference_contains
    isNewDevelopment_eq
    hasBalcony_eq
    hasGarden_eq
    hasParking_eq
    hasElevator_eq
    hasView_eq
    hasFireplace_eq
    hasGarage_eq
    isChildFriendly_eq
    isWheelchairAccessible_eq
    isMinergieCertified_eq
    isFurnished_eq
    bookOnline_eq
    isFsbo_eq
    places {
      type
      label
      municipality: parentPlace(type: municipality) {
        label
        id
      }
      state: parentPlace(type: state) {
        label
        id
      }
      id
    }
  }
  totalCount
  edges {
    node {
      id
      encodedId
    }
  }
}

fragment AggregatesListingsBreadcrumbs_aggregatesListings on AggregatesListingConnectionConnection {
  filters {
    places {
      breadcrumbs {
        slug
        lang
        label
        canonicalPlace {
          slug
          id
        }
        id
      }
      id
    }
  }
}

fragment AggregatesListingsFAQ_place on Place {
  type
  slug
  parentPlace(type: municipality) {
    placeForLink(returnSelfIfIndexIsTrue: true) {
      slug
      id
    }
    id
  }
  stats: listingsStatsOptional(propertyMainType: $propertyMainType, numberOfRooms: $numberOfRooms) {
    saleOffersCount
    rentOffersCount
    saleOffersCount3Month
    rentOffersCount3Month
    salePrice {
      percentile10
      median
      percentile90
    }
    salePricePerM2 {
      median
    }
    monthlyRent {
      percentile10
      median
      percentile90
    }
    yearlyRentPerM2 {
      median
    }
  }
  rating: municipalitiesRating(propertyMainType: $propertyMainType, numberOfRooms: $numberOfRooms, offerType: $offerType) {
    cheapest {
      label
      place {
        placeForLink(returnSelfIfIndexIsTrue: false) {
          slug
          id
        }
        id
      }
      value
      id
    }
    expensive {
      label
      place {
        placeForLink(returnSelfIfIndexIsTrue: false) {
          slug
          id
        }
        id
      }
      value
      id
    }
    popular {
      label
      place {
        placeForLink(returnSelfIfIndexIsTrue: false) {
          slug
          id
        }
        id
      }
      value
      id
    }
  }
}

fragment AggregatesListingsFilters_page on CMSPage {
  ...TopFilters_page
}

fragment AggregatesListingsFilters_root on Query {
  ...TopFilters_root
  aggregatesListingInfo {
    minSalePrice
    maxSalePrice
    minGrossRentMonthly
    maxGrossRentMonthly
    minGrossRentM2yearly
    maxGrossRentM2yearly
    minGrossRentRoomMonthly
    maxGrossRentRoomMonthly
    minSalePricePerLivingSurface
    maxSalePricePerLivingSurface
    minSalePricePerLandSurface
    maxSalePricePerLandSurface
    minNumberOfRooms
    maxNumberOfRooms
    minNumberOfBathrooms
    maxNumberOfBathrooms
    minLivingSurface
    maxLivingSurface
    minLandSurface
    maxLandSurface
    minTerraceSurface
    maxTerraceSurface
    minBalconySurface
    maxBalconySurface
    minGardenSurface
    maxGardenSurface
    minNumberOfParkings
    maxNumberOfParkings
    portals {
      id
      title
    }
    id
  }
}

fragment AggregatesListingsItems_aggregatesListings_VTAHT on AggregatesListingConnectionConnection {
  edges {
    node {
      id
      title
      slug
      propertyMainType
      propertyType
      compositePropertyType
      portal
      offerType
      salePrice
      grossRentMonthly
      postcode
      subLocality
      locality
      lat
      lng
      computedSurface
      numberOfRooms
      numberOfBathrooms
      numberOfParking
      constructionYear
      renovationYear
      agencyId
      agencyName
      ...AggregatesListingCard_listing_VTAHT
    }
  }
}

fragment AggregatesListingsMap_aggregatesListings on AggregatesListingConnectionConnection {
  similarItems {
    id
    clusterIds
    lat
    lng
  }
}

fragment AggregatesListingsPageMeta_aggregatesListings on AggregatesListingConnectionConnection {
  totalCount
  edges {
    node {
      firstImage: images(first: 1) {
        bucketName
        fileName
        id
      }
      id
    }
  }
}

fragment AggregatesListingsPageMeta_root on Query {
  cms {
    pageWithData(uid: $uid, lang: $lang) {
      page {
        description
      }
    }
  }
}

fragment AggregatesListingsSEOLinks_place on Place {
  type
  neighbouringAlternatives {
    label
    inLabel
    type
    slug
    lang
    id
  }
  innerAlternatives {
    label
    inLabel
    type
    slug
    lang
    id
  }
}

fragment AggregatesListingsSEOLinks_popularSearches on AggregatorCustomPage {
  h1
  slug
}

fragment AggregatesListingsSimilarItems_aggregatesListings on AggregatesListingConnectionConnection {
  similarItems {
    ...AggregatesListingCard_listing
    id
  }
}

fragment AggregatesListings_page on CMSPage {
  ...AggregatesListingsFilters_page
}

fragment AggregatesListings_root on Query {
  ...AggregatesListingsFilters_root
  ...AggregatesListingsPageMeta_root
  aggregatesListings(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, filters: $filters) {
    ...AggregatesListingsAnalytics_aggregatesListings
    ...AggregatesListingsBreadcrumbs_aggregatesListings
    ...AggregatesListingsItems_aggregatesListings_VTAHT
    ...useAggregatesListingsPlaceData_aggregatesListings
    ...AggregatesListingsSimilarItems_aggregatesListings
    ...AggregatesListingsMap_aggregatesListings
    ...AggregatesListingsPageMeta_aggregatesListings
    ...aggregatesListingAlertDialog_aggregatesListings
    totalCount
    similarItems {
      id
    }
    searchBounds {
      ne {
        lat
        lng
      }
      sw {
        lat
        lng
      }
    }
    searchGeometries {
      id
      geog {
        type
        coordinates
      }
    }
  }
  placeBySlug(slug: $slug, lang: $lngShort) @include(if: $includePlace) {
    ...AggregatesListingsSEOLinks_place
    ...AggregatesListingsFAQ_place
    canonicalPlace {
      slug
      lang
      id
    }
    index
    indexRooms
    id
  }
  aggregatorCustomPagesByPlace(placeSlug: $slug, offerType: $offerType, language: $lngShort) {
    ...AggregatesListingsSEOLinks_popularSearches
    id
  }
  country @include(if: $includeCountry) {
    ...AggregatesListingsSEOLinks_place
    ...AggregatesListingsFAQ_place
    id
  }
}

fragment Breadcrumbs_hierarchy on CMSPage {
  template
  link_title
  custom_path
  _meta {
    uid
  }
}

fragment CheckedFilters_filters on AggregatesListingFilters {
  offerType_eq
  places {
    label
    id
  }
  compositePropertyType_eq
  livingSurface_lte
  livingSurface_gte
  landSurface_lte
  landSurface_gte
  hasBalcony_eq
  hasGarden_eq
  hasParking_eq
  hasElevator_eq
  hasView_eq
  hasFireplace_eq
  hasGarage_eq
  isFurnished_eq
  bookOnline_eq
  isFsbo_eq
  isChildFriendly_eq
  isWheelchairAccessible_eq
  isMinergieCertified_eq
  isNewDevelopment_eq
  salePrice_lte
  salePrice_gte
  grossRentMonthly_lte
  grossRentMonthly_gte
  salePricePerLivingSurface_gte
  salePricePerLivingSurface_lte
  agencyReference_contains
  agencyNames
  salePricePerLandSurface_lte
  salePricePerLandSurface_gte
  grossRentRoomMonthly_lte
  grossRentRoomMonthly_gte
  grossRentM2yearly_lte
  grossRentM2yearly_gte
  numberOfRooms_gte
  numberOfRooms_lte
  portal_in
}

fragment Layout_pageWithData on CMSPageWithData {
  hierarchy {
    ...Breadcrumbs_hierarchy
  }
  page {
    template
    canonical_url {
      __typename
      ... on CMS_ExternalLink {
        url
      }
      ... on CMSPage {
        _meta {
          uid
          lang
        }
      }
    }
    meta_robots
    show_phone
    _meta {
      id
      lang
      alternateLanguages {
        uid
        lang
        id
      }
    }
  }
}

fragment Layout_root_3iqx2P on Query {
  cms {
    navigation(uid: "main", lang: $lang) {
      nav_logo_link {
        __typename
        ... on CMSPage {
          template
          _meta {
            uid
            lang
          }
        }
      }
      phone_number
      body {
        __typename
        ... on CMSNavigationBodyNavigation_item {
          primary {
            label
            pathname
            nav_link {
              __typename
              ... on CMSPage {
                template
                _meta {
                  id
                  uid
                  lang
                }
              }
            }
          }
          fields {
            label
            pathname
            sub_nav_link {
              __typename
              ... on CMSPage {
                template
                _meta {
                  uid
                  lang
                }
              }
            }
          }
        }
      }
    }
    footerNavigation: navigation(uid: "footer", lang: $lang) {
      phone_number
    }
  }
}

fragment TopFilters_page on CMSPage {
  ...countrySwitcher_page
}

fragment TopFilters_root on Query {
  aggregatesListings(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, filters: $filters) {
    filters {
      places {
        slug
        lang
        label
        id
      }
    }
  }
}

fragment aggregatesListingAlertDialog_aggregatesListings on AggregatesListingConnectionConnection {
  filters {
    ...CheckedFilters_filters
  }
}

fragment aggregatesListingDialogClient_aggregatesListings on AggregatesListingConnectionConnection {
  ...aggregatesListingDialog_aggregatesListings
}

fragment aggregatesListingDialog_aggregatesListings on AggregatesListingConnectionConnection {
  totalCount
  filters {
    places {
      label
      id
    }
  }
  ...AggregatesListing_aggregatesListings
}

fragment countrySwitcher_page on CMSPage {
  template
  _meta {
    uid
    lang
    alternateLanguages {
      uid
      lang
    }
  }
}

fragment useAggregatesListingsPlaceData_aggregatesListings on AggregatesListingConnectionConnection {
  filters {
    places {
      slugEn: slug(lang: en)
      type
      label
      inLabel
      indexRooms
      id
    }
  }
}

fragment useListingStructuredData_listing on AggregatesListing {
  currency
  images(first: 100) {
    bucketName
    fileName
    id
  }
  grossRentMonthly
  livingSurface
  numberOfRooms
  postcode
  propertyMainType
  lat
  lng
  propertyType
  route
  salePrice
  streetNumber
  subLocality
  encodedId
  offerType
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeCountry"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDe"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeEn"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeEs"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFr"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeIt"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includePlace"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lngShort"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfRooms"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerType"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyMainType"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uid"
},
v18 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v19 = [
  (v18/*: any*/),
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v24 = {
  "alias": "slugEn",
  "args": [
    {
      "kind": "Literal",
      "name": "lang",
      "value": "en"
    }
  ],
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": "slug(lang:\"en\")"
},
v25 = {
  "condition": "includeFr",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "slugFr",
      "args": [
        {
          "kind": "Literal",
          "name": "lang",
          "value": "fr"
        }
      ],
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": "slug(lang:\"fr\")"
    }
  ]
},
v26 = {
  "condition": "includeDe",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "slugDe",
      "args": [
        {
          "kind": "Literal",
          "name": "lang",
          "value": "de"
        }
      ],
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": "slug(lang:\"de\")"
    }
  ]
},
v27 = {
  "condition": "includeIt",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "slugIt",
      "args": [
        {
          "kind": "Literal",
          "name": "lang",
          "value": "it"
        }
      ],
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": "slug(lang:\"it\")"
    }
  ]
},
v28 = {
  "condition": "includeEs",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "slugEs",
      "args": [
        {
          "kind": "Literal",
          "name": "lang",
          "value": "es"
        }
      ],
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": "slug(lang:\"es\")"
    }
  ]
},
v29 = {
  "kind": "Variable",
  "name": "lang",
  "variableName": "lang"
},
v30 = [
  (v29/*: any*/),
  {
    "kind": "Variable",
    "name": "uid",
    "variableName": "uid"
  }
],
v31 = [
  (v29/*: any*/),
  {
    "kind": "Literal",
    "name": "uid",
    "value": "main"
  }
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "CMSMeta",
  "kind": "LinkedField",
  "name": "_meta",
  "plural": false,
  "selections": [
    (v33/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    (v32/*: any*/),
    (v34/*: any*/)
  ],
  "type": "CMSPage",
  "abstractKey": null
},
v36 = [
  (v35/*: any*/)
],
v37 = [
  {
    "kind": "Variable",
    "name": "lang",
    "variableName": "lngShort"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCanonical",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lang",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "CMSMeta",
  "kind": "LinkedField",
  "name": "_meta",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v39/*: any*/)
  ],
  "storageKey": null
},
v43 = [
  (v41/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v32/*: any*/),
      (v42/*: any*/)
    ],
    "type": "CMSPage",
    "abstractKey": null
  }
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone_number",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pathname",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v48 = [
  (v41/*: any*/),
  (v35/*: any*/)
],
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v50 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "municipality"
  }
],
v51 = [
  (v45/*: any*/),
  (v47/*: any*/)
],
v52 = [
  (v23/*: any*/),
  (v47/*: any*/)
],
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inLabel",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "indexRooms",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "encodedId",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyMainType",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyType",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "compositePropertyType",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerType",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePrice",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossRentMonthly",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postcode",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subLocality",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locality",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfRooms",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBathrooms",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "constructionYear",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agencyName",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bucketName",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100
    }
  ],
  "concreteType": "AggregatesListingImage",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v73/*: any*/),
    (v74/*: any*/),
    (v47/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blurhash",
      "storageKey": null
    }
  ],
  "storageKey": "images(first:100)"
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingSurface",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "route",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetNumber",
  "storageKey": null
},
v79 = [
  {
    "kind": "Literal",
    "name": "sentences",
    "value": 3
  }
],
v80 = {
  "alias": "shortDescription",
  "args": (v79/*: any*/),
  "kind": "ScalarField",
  "name": "description",
  "storageKey": "description(sentences:3)"
},
v81 = {
  "alias": "shortTranslatedDescription",
  "args": (v79/*: any*/),
  "kind": "ScalarField",
  "name": "translatedDescription",
  "storageKey": "translatedDescription(sentences:3)"
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bulletPoints",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavourite",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usableSurface",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landSurface",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossRentM2yearly",
  "storageKey": null
},
v87 = [
  (v49/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "originalDomain",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "originalUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mergedListingId",
    "storageKey": null
  }
],
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translatedTitle",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePricePerLivingSurface",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePricePerLandSurface",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitContactPerson",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agencyReference",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lotReference",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "Place",
  "kind": "LinkedField",
  "name": "stateObject",
  "plural": false,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "Place",
  "kind": "LinkedField",
  "name": "municipalityObject",
  "plural": false,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v98 = [
  (v66/*: any*/),
  (v67/*: any*/)
],
v99 = {
  "kind": "Variable",
  "name": "offerType",
  "variableName": "offerType"
},
v100 = [
  (v45/*: any*/),
  (v53/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v39/*: any*/),
  (v47/*: any*/)
],
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "Place",
  "kind": "LinkedField",
  "name": "neighbouringAlternatives",
  "plural": true,
  "selections": (v100/*: any*/),
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "concreteType": "Place",
  "kind": "LinkedField",
  "name": "innerAlternatives",
  "plural": true,
  "selections": (v100/*: any*/),
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": (v50/*: any*/),
  "concreteType": "Place",
  "kind": "LinkedField",
  "name": "parentPlace",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "returnSelfIfIndexIsTrue",
          "value": true
        }
      ],
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "placeForLink",
      "plural": false,
      "selections": (v52/*: any*/),
      "storageKey": "placeForLink(returnSelfIfIndexIsTrue:true)"
    },
    (v47/*: any*/)
  ],
  "storageKey": "parentPlace(type:\"municipality\")"
},
v104 = {
  "kind": "Variable",
  "name": "numberOfRooms",
  "variableName": "numberOfRooms"
},
v105 = {
  "kind": "Variable",
  "name": "propertyMainType",
  "variableName": "propertyMainType"
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "median",
  "storageKey": null
},
v107 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentile10",
    "storageKey": null
  },
  (v106/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentile90",
    "storageKey": null
  }
],
v108 = [
  (v106/*: any*/)
],
v109 = {
  "alias": "stats",
  "args": [
    (v104/*: any*/),
    (v105/*: any*/)
  ],
  "concreteType": "ListingsStats",
  "kind": "LinkedField",
  "name": "listingsStatsOptional",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saleOffersCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rentOffersCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saleOffersCount3Month",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rentOffersCount3Month",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ListingsValueStats",
      "kind": "LinkedField",
      "name": "salePrice",
      "plural": false,
      "selections": (v107/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ListingsValueStats",
      "kind": "LinkedField",
      "name": "salePricePerM2",
      "plural": false,
      "selections": (v108/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ListingsValueStats",
      "kind": "LinkedField",
      "name": "monthlyRent",
      "plural": false,
      "selections": (v107/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ListingsValueStats",
      "kind": "LinkedField",
      "name": "yearlyRentPerM2",
      "plural": false,
      "selections": (v108/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v110 = [
  (v45/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Place",
    "kind": "LinkedField",
    "name": "place",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "returnSelfIfIndexIsTrue",
            "value": false
          }
        ],
        "concreteType": "Place",
        "kind": "LinkedField",
        "name": "placeForLink",
        "plural": false,
        "selections": (v52/*: any*/),
        "storageKey": "placeForLink(returnSelfIfIndexIsTrue:false)"
      },
      (v47/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  (v47/*: any*/)
],
v111 = {
  "alias": "rating",
  "args": [
    (v104/*: any*/),
    (v99/*: any*/),
    (v105/*: any*/)
  ],
  "concreteType": "MunicipalitiesRating",
  "kind": "LinkedField",
  "name": "municipalitiesRating",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MunicipalitiesRatingValues",
      "kind": "LinkedField",
      "name": "cheapest",
      "plural": true,
      "selections": (v110/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MunicipalitiesRatingValues",
      "kind": "LinkedField",
      "name": "expensive",
      "plural": true,
      "selections": (v110/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MunicipalitiesRatingValues",
      "kind": "LinkedField",
      "name": "popular",
      "plural": true,
      "selections": (v110/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "listingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "AggregatesListingConnectionConnection",
        "kind": "LinkedField",
        "name": "aggregatesListings",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AggregatesListingFilters",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "places",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "condition": "includeEn",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v24/*: any*/)
                    ]
                  },
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "aggregatesListingDialogClient_aggregatesListings"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v30/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "page",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TopFilters_page"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AggregatesListings_page"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Layout_pageWithData"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v31/*: any*/),
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nav_listings_buy_logo_link",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nav_listings_rent_logo_link",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v29/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "Layout_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AggregatesListings_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AggregatesListingsFilters_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TopFilters_root"
      },
      {
        "condition": "includePlace",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v37/*: any*/),
            "concreteType": "Place",
            "kind": "LinkedField",
            "name": "placeBySlug",
            "plural": false,
            "selections": [
              (v38/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "canonicalPlace",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v39/*: any*/)
                ],
                "storageKey": null
              },
              (v40/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v15/*: any*/),
      (v16/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v17/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v13/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "listingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v31/*: any*/),
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nav_logo_link",
                "plural": false,
                "selections": (v43/*: any*/),
                "storageKey": null
              },
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "body",
                "plural": true,
                "selections": [
                  (v41/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSNavigationBodyNavigation_itemPrimary",
                        "kind": "LinkedField",
                        "name": "primary",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/),
                          (v46/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "nav_link",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v32/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CMSMeta",
                                    "kind": "LinkedField",
                                    "name": "_meta",
                                    "plural": false,
                                    "selections": [
                                      (v47/*: any*/),
                                      (v33/*: any*/),
                                      (v39/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "CMSPage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSNavigationBodyNavigation_itemFields",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          (v45/*: any*/),
                          (v46/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "sub_nav_link",
                            "plural": false,
                            "selections": (v43/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CMSNavigationBodyNavigation_item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nav_listings_buy_logo_link",
                "plural": false,
                "selections": (v48/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nav_listings_rent_logo_link",
                "plural": false,
                "selections": (v48/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "footerNavigation",
            "args": [
              (v29/*: any*/),
              {
                "kind": "Literal",
                "name": "uid",
                "value": "footer"
              }
            ],
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              (v44/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v30/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "page",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSMeta",
                    "kind": "LinkedField",
                    "name": "_meta",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSRelatedDocument",
                        "kind": "LinkedField",
                        "name": "alternateLanguages",
                        "plural": true,
                        "selections": [
                          (v33/*: any*/),
                          (v39/*: any*/),
                          (v47/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v47/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "canonical_url",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v49/*: any*/)
                        ],
                        "type": "CMS_ExternalLink",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/)
                        ],
                        "type": "CMSPage",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meta_robots",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "show_phone",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "hierarchy",
                "plural": true,
                "selections": [
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link_title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_path",
                    "storageKey": null
                  },
                  (v34/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "AggregatesListingConnectionConnection",
        "kind": "LinkedField",
        "name": "aggregatesListings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AggregatesListingFilters",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "places",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v39/*: any*/),
                  (v45/*: any*/),
                  (v47/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": "municipality",
                    "args": (v50/*: any*/),
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "parentPlace",
                    "plural": false,
                    "selections": (v51/*: any*/),
                    "storageKey": "parentPlace(type:\"municipality\")"
                  },
                  {
                    "alias": "state",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "state"
                      }
                    ],
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "parentPlace",
                    "plural": false,
                    "selections": (v51/*: any*/),
                    "storageKey": "parentPlace(type:\"state\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v23/*: any*/),
                      (v39/*: any*/),
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Place",
                        "kind": "LinkedField",
                        "name": "canonicalPlace",
                        "plural": false,
                        "selections": (v52/*: any*/),
                        "storageKey": null
                      },
                      (v47/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v21/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "offerType_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salePrice_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salePrice_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grossRentMonthly_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grossRentMonthly_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grossRentM2yearly_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grossRentM2yearly_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grossRentRoomMonthly_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grossRentRoomMonthly_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salePricePerLivingSurface_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salePricePerLivingSurface_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salePricePerLandSurface_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salePricePerLandSurface_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfRooms_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfRooms_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "livingSurface_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "livingSurface_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "landSurface_lte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "landSurface_gte",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "compositePropertyType_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portal_in",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "agencyReference_contains",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNewDevelopment_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasBalcony_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasGarden_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasParking_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasElevator_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasView_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasFireplace_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasGarage_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isChildFriendly_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isWheelchairAccessible_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMinergieCertified_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFurnished_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bookOnline_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFsbo_eq",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "agencyNames",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AggregatesListingConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AggregatesListing",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v47/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v23/*: any*/),
                  (v57/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "portal",
                    "storageKey": null
                  },
                  (v60/*: any*/),
                  (v61/*: any*/),
                  (v62/*: any*/),
                  (v63/*: any*/),
                  (v64/*: any*/),
                  (v65/*: any*/),
                  (v66/*: any*/),
                  (v67/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "computedSurface",
                    "storageKey": null
                  },
                  (v68/*: any*/),
                  (v69/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfParking",
                    "storageKey": null
                  },
                  (v70/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "renovationYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "agencyId",
                    "storageKey": null
                  },
                  (v71/*: any*/),
                  (v72/*: any*/),
                  (v75/*: any*/),
                  (v76/*: any*/),
                  (v77/*: any*/),
                  (v78/*: any*/),
                  (v80/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      (v18/*: any*/)
                    ],
                    "concreteType": "ExternalUrl",
                    "kind": "LinkedField",
                    "name": "url",
                    "plural": false,
                    "selections": (v87/*: any*/),
                    "storageKey": null
                  },
                  (v88/*: any*/),
                  (v89/*: any*/),
                  (v90/*: any*/),
                  (v91/*: any*/),
                  (v92/*: any*/),
                  (v93/*: any*/),
                  (v94/*: any*/),
                  (v95/*: any*/),
                  (v96/*: any*/),
                  (v97/*: any*/),
                  {
                    "alias": "firstImage",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      }
                    ],
                    "concreteType": "AggregatesListingImage",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v73/*: any*/),
                      (v74/*: any*/),
                      (v47/*: any*/)
                    ],
                    "storageKey": "images(first:1)"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AggregatesListing",
            "kind": "LinkedField",
            "name": "similarItems",
            "plural": true,
            "selections": [
              (v72/*: any*/),
              (v75/*: any*/),
              (v62/*: any*/),
              (v76/*: any*/),
              (v68/*: any*/),
              (v63/*: any*/),
              (v57/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v58/*: any*/),
              (v77/*: any*/),
              (v61/*: any*/),
              (v78/*: any*/),
              (v64/*: any*/),
              (v55/*: any*/),
              (v60/*: any*/),
              (v47/*: any*/),
              (v23/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              (v85/*: any*/),
              (v86/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExternalUrl",
                "kind": "LinkedField",
                "name": "url",
                "plural": false,
                "selections": (v87/*: any*/),
                "storageKey": null
              },
              (v88/*: any*/),
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v59/*: any*/),
              (v92/*: any*/),
              (v71/*: any*/),
              (v93/*: any*/),
              (v94/*: any*/),
              (v70/*: any*/),
              (v65/*: any*/),
              (v95/*: any*/),
              (v96/*: any*/),
              (v97/*: any*/),
              (v69/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clusterIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeoBounds",
            "kind": "LinkedField",
            "name": "searchBounds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GeoLatLng",
                "kind": "LinkedField",
                "name": "ne",
                "plural": false,
                "selections": (v98/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GeoLatLng",
                "kind": "LinkedField",
                "name": "sw",
                "plural": false,
                "selections": (v98/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AggregatesListingsGeoType",
            "kind": "LinkedField",
            "name": "searchGeometries",
            "plural": true,
            "selections": [
              (v47/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GeoJSONMultiPolygon",
                "kind": "LinkedField",
                "name": "geog",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coordinates",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AggregatesListingInfo",
        "kind": "LinkedField",
        "name": "aggregatesListingInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minSalePrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxSalePrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minGrossRentMonthly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxGrossRentMonthly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minGrossRentM2yearly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxGrossRentM2yearly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minGrossRentRoomMonthly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxGrossRentRoomMonthly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minSalePricePerLivingSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxSalePricePerLivingSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minSalePricePerLandSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxSalePricePerLandSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minNumberOfRooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxNumberOfRooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minNumberOfBathrooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxNumberOfBathrooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minLivingSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxLivingSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minLandSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxLandSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minTerraceSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxTerraceSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minBalconySurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxBalconySurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minGardenSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxGardenSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minNumberOfParkings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxNumberOfParkings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Portals",
            "kind": "LinkedField",
            "name": "portals",
            "plural": true,
            "selections": [
              (v47/*: any*/),
              (v56/*: any*/)
            ],
            "storageKey": null
          },
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "language",
            "variableName": "lngShort"
          },
          (v99/*: any*/),
          {
            "kind": "Variable",
            "name": "placeSlug",
            "variableName": "slug"
          }
        ],
        "concreteType": "AggregatorCustomPage",
        "kind": "LinkedField",
        "name": "aggregatorCustomPagesByPlace",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "h1",
            "storageKey": null
          },
          (v23/*: any*/),
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "includePlace",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v37/*: any*/),
            "concreteType": "Place",
            "kind": "LinkedField",
            "name": "placeBySlug",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v101/*: any*/),
              (v102/*: any*/),
              (v23/*: any*/),
              (v103/*: any*/),
              (v109/*: any*/),
              (v111/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "canonicalPlace",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v39/*: any*/),
                  (v47/*: any*/)
                ],
                "storageKey": null
              },
              (v40/*: any*/),
              (v54/*: any*/),
              (v47/*: any*/),
              (v38/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "includeCountry",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Place",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v101/*: any*/),
              (v102/*: any*/),
              (v23/*: any*/),
              (v103/*: any*/),
              (v109/*: any*/),
              (v111/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ff42a615c85d33ac2d43ad9e948ab4e5",
    "id": null,
    "metadata": {},
    "name": "listingsQuery",
    "operationKind": "query",
    "text": "query listingsQuery(\n  $sortBy: String\n  $sortDirection: String\n  $filters: AggregatesListingFiltersInput!\n  $page: AggregatesListingFiltersPage\n  $slug: String!\n  $includePlace: Boolean!\n  $includeCountry: Boolean!\n  $uid: String!\n  $lang: String!\n  $lngShort: LangInput!\n  $propertyMainType: PropertyMainType\n  $numberOfRooms: Float\n  $offerType: String!\n  $includeEn: Boolean!\n  $includeFr: Boolean!\n  $includeDe: Boolean!\n  $includeIt: Boolean!\n  $includeEs: Boolean!\n) {\n  ...Layout_root_3iqx2P\n  ...AggregatesListings_root\n  ...AggregatesListingsFilters_root\n  ...TopFilters_root\n  aggregatesListings(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, filters: $filters) {\n    ...aggregatesListingDialogClient_aggregatesListings\n    totalCount\n    filters {\n      places {\n        countryCode\n        type\n        slug\n        slugEn: slug(lang: en) @include(if: $includeEn)\n        slugFr: slug(lang: fr) @include(if: $includeFr)\n        slugDe: slug(lang: de) @include(if: $includeDe)\n        slugIt: slug(lang: it) @include(if: $includeIt)\n        slugEs: slug(lang: es) @include(if: $includeEs)\n        id\n      }\n    }\n  }\n  placeBySlug(slug: $slug, lang: $lngShort) @include(if: $includePlace) {\n    hasCanonical\n    canonicalPlace {\n      slug\n      lang\n      id\n    }\n    index\n    id\n  }\n  cms {\n    pageWithData(uid: $uid, lang: $lang) {\n      page {\n        ...TopFilters_page\n        ...AggregatesListings_page\n      }\n      ...Layout_pageWithData\n    }\n    navigation(uid: \"main\", lang: $lang) {\n      nav_listings_buy_logo_link {\n        __typename\n        ... on CMSPage {\n          template\n          _meta {\n            uid\n          }\n        }\n      }\n      nav_listings_rent_logo_link {\n        __typename\n        ... on CMSPage {\n          template\n          _meta {\n            uid\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AggregatesListingCard_listing on AggregatesListing {\n  ...useListingStructuredData_listing\n  id\n  slug\n  encodedId\n  offerType\n  shortDescription: description(sentences: 3)\n  shortTranslatedDescription: translatedDescription(sentences: 3)\n  bulletPoints\n  propertyType\n  numberOfRooms\n  livingSurface\n  isFavourite\n  usableSurface\n  landSurface\n  salePrice\n  grossRentMonthly\n  grossRentM2yearly\n  currency\n  postcode\n  subLocality\n  route\n  streetNumber\n  images(first: 100) {\n    bucketName\n    fileName\n    blurhash\n    id\n  }\n  url {\n    url\n    originalDomain\n    originalUrl\n    mergedListingId\n  }\n  translatedTitle\n  salePricePerLivingSurface\n  salePricePerLandSurface\n  createdAt\n  propertyMainType\n  compositePropertyType\n  visitContactPerson\n  agencyName\n  agencyReference\n  lotReference\n  constructionYear\n  locality\n  stateObject {\n    label\n    id\n  }\n  municipalityObject {\n    label\n    id\n  }\n  lat\n  lng\n  address\n  numberOfBathrooms\n}\n\nfragment AggregatesListingCard_listing_VTAHT on AggregatesListing {\n  ...useListingStructuredData_listing\n  id\n  slug\n  encodedId\n  offerType\n  shortDescription: description(sentences: 3)\n  shortTranslatedDescription: translatedDescription(sentences: 3)\n  bulletPoints\n  propertyType\n  numberOfRooms\n  livingSurface\n  isFavourite\n  usableSurface\n  landSurface\n  salePrice\n  grossRentMonthly\n  grossRentM2yearly\n  currency\n  postcode\n  subLocality\n  route\n  streetNumber\n  images(first: 100) {\n    bucketName\n    fileName\n    blurhash\n    id\n  }\n  url(filters: $filters) {\n    url\n    originalDomain\n    originalUrl\n    mergedListingId\n  }\n  translatedTitle\n  salePricePerLivingSurface\n  salePricePerLandSurface\n  createdAt\n  propertyMainType\n  compositePropertyType\n  visitContactPerson\n  agencyName\n  agencyReference\n  lotReference\n  constructionYear\n  locality\n  stateObject {\n    label\n    id\n  }\n  municipalityObject {\n    label\n    id\n  }\n  lat\n  lng\n  address\n  numberOfBathrooms\n}\n\nfragment AggregatesListing_aggregatesListings on AggregatesListingConnectionConnection {\n  ...aggregatesListingAlertDialog_aggregatesListings\n}\n\nfragment AggregatesListingsAnalytics_aggregatesListings on AggregatesListingConnectionConnection {\n  filters {\n    offerType_eq\n    salePrice_lte\n    salePrice_gte\n    createdAt_gte\n    grossRentMonthly_lte\n    grossRentMonthly_gte\n    grossRentM2yearly_lte\n    grossRentM2yearly_gte\n    grossRentRoomMonthly_lte\n    grossRentRoomMonthly_gte\n    salePricePerLivingSurface_lte\n    salePricePerLivingSurface_gte\n    salePricePerLandSurface_lte\n    salePricePerLandSurface_gte\n    numberOfRooms_lte\n    numberOfRooms_gte\n    livingSurface_lte\n    livingSurface_gte\n    landSurface_lte\n    landSurface_gte\n    compositePropertyType_eq\n    portal_in\n    agencyReference_contains\n    isNewDevelopment_eq\n    hasBalcony_eq\n    hasGarden_eq\n    hasParking_eq\n    hasElevator_eq\n    hasView_eq\n    hasFireplace_eq\n    hasGarage_eq\n    isChildFriendly_eq\n    isWheelchairAccessible_eq\n    isMinergieCertified_eq\n    isFurnished_eq\n    bookOnline_eq\n    isFsbo_eq\n    places {\n      type\n      label\n      municipality: parentPlace(type: municipality) {\n        label\n        id\n      }\n      state: parentPlace(type: state) {\n        label\n        id\n      }\n      id\n    }\n  }\n  totalCount\n  edges {\n    node {\n      id\n      encodedId\n    }\n  }\n}\n\nfragment AggregatesListingsBreadcrumbs_aggregatesListings on AggregatesListingConnectionConnection {\n  filters {\n    places {\n      breadcrumbs {\n        slug\n        lang\n        label\n        canonicalPlace {\n          slug\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment AggregatesListingsFAQ_place on Place {\n  type\n  slug\n  parentPlace(type: municipality) {\n    placeForLink(returnSelfIfIndexIsTrue: true) {\n      slug\n      id\n    }\n    id\n  }\n  stats: listingsStatsOptional(propertyMainType: $propertyMainType, numberOfRooms: $numberOfRooms) {\n    saleOffersCount\n    rentOffersCount\n    saleOffersCount3Month\n    rentOffersCount3Month\n    salePrice {\n      percentile10\n      median\n      percentile90\n    }\n    salePricePerM2 {\n      median\n    }\n    monthlyRent {\n      percentile10\n      median\n      percentile90\n    }\n    yearlyRentPerM2 {\n      median\n    }\n  }\n  rating: municipalitiesRating(propertyMainType: $propertyMainType, numberOfRooms: $numberOfRooms, offerType: $offerType) {\n    cheapest {\n      label\n      place {\n        placeForLink(returnSelfIfIndexIsTrue: false) {\n          slug\n          id\n        }\n        id\n      }\n      value\n      id\n    }\n    expensive {\n      label\n      place {\n        placeForLink(returnSelfIfIndexIsTrue: false) {\n          slug\n          id\n        }\n        id\n      }\n      value\n      id\n    }\n    popular {\n      label\n      place {\n        placeForLink(returnSelfIfIndexIsTrue: false) {\n          slug\n          id\n        }\n        id\n      }\n      value\n      id\n    }\n  }\n}\n\nfragment AggregatesListingsFilters_page on CMSPage {\n  ...TopFilters_page\n}\n\nfragment AggregatesListingsFilters_root on Query {\n  ...TopFilters_root\n  aggregatesListingInfo {\n    minSalePrice\n    maxSalePrice\n    minGrossRentMonthly\n    maxGrossRentMonthly\n    minGrossRentM2yearly\n    maxGrossRentM2yearly\n    minGrossRentRoomMonthly\n    maxGrossRentRoomMonthly\n    minSalePricePerLivingSurface\n    maxSalePricePerLivingSurface\n    minSalePricePerLandSurface\n    maxSalePricePerLandSurface\n    minNumberOfRooms\n    maxNumberOfRooms\n    minNumberOfBathrooms\n    maxNumberOfBathrooms\n    minLivingSurface\n    maxLivingSurface\n    minLandSurface\n    maxLandSurface\n    minTerraceSurface\n    maxTerraceSurface\n    minBalconySurface\n    maxBalconySurface\n    minGardenSurface\n    maxGardenSurface\n    minNumberOfParkings\n    maxNumberOfParkings\n    portals {\n      id\n      title\n    }\n    id\n  }\n}\n\nfragment AggregatesListingsItems_aggregatesListings_VTAHT on AggregatesListingConnectionConnection {\n  edges {\n    node {\n      id\n      title\n      slug\n      propertyMainType\n      propertyType\n      compositePropertyType\n      portal\n      offerType\n      salePrice\n      grossRentMonthly\n      postcode\n      subLocality\n      locality\n      lat\n      lng\n      computedSurface\n      numberOfRooms\n      numberOfBathrooms\n      numberOfParking\n      constructionYear\n      renovationYear\n      agencyId\n      agencyName\n      ...AggregatesListingCard_listing_VTAHT\n    }\n  }\n}\n\nfragment AggregatesListingsMap_aggregatesListings on AggregatesListingConnectionConnection {\n  similarItems {\n    id\n    clusterIds\n    lat\n    lng\n  }\n}\n\nfragment AggregatesListingsPageMeta_aggregatesListings on AggregatesListingConnectionConnection {\n  totalCount\n  edges {\n    node {\n      firstImage: images(first: 1) {\n        bucketName\n        fileName\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment AggregatesListingsPageMeta_root on Query {\n  cms {\n    pageWithData(uid: $uid, lang: $lang) {\n      page {\n        description\n      }\n    }\n  }\n}\n\nfragment AggregatesListingsSEOLinks_place on Place {\n  type\n  neighbouringAlternatives {\n    label\n    inLabel\n    type\n    slug\n    lang\n    id\n  }\n  innerAlternatives {\n    label\n    inLabel\n    type\n    slug\n    lang\n    id\n  }\n}\n\nfragment AggregatesListingsSEOLinks_popularSearches on AggregatorCustomPage {\n  h1\n  slug\n}\n\nfragment AggregatesListingsSimilarItems_aggregatesListings on AggregatesListingConnectionConnection {\n  similarItems {\n    ...AggregatesListingCard_listing\n    id\n  }\n}\n\nfragment AggregatesListings_page on CMSPage {\n  ...AggregatesListingsFilters_page\n}\n\nfragment AggregatesListings_root on Query {\n  ...AggregatesListingsFilters_root\n  ...AggregatesListingsPageMeta_root\n  aggregatesListings(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, filters: $filters) {\n    ...AggregatesListingsAnalytics_aggregatesListings\n    ...AggregatesListingsBreadcrumbs_aggregatesListings\n    ...AggregatesListingsItems_aggregatesListings_VTAHT\n    ...useAggregatesListingsPlaceData_aggregatesListings\n    ...AggregatesListingsSimilarItems_aggregatesListings\n    ...AggregatesListingsMap_aggregatesListings\n    ...AggregatesListingsPageMeta_aggregatesListings\n    ...aggregatesListingAlertDialog_aggregatesListings\n    totalCount\n    similarItems {\n      id\n    }\n    searchBounds {\n      ne {\n        lat\n        lng\n      }\n      sw {\n        lat\n        lng\n      }\n    }\n    searchGeometries {\n      id\n      geog {\n        type\n        coordinates\n      }\n    }\n  }\n  placeBySlug(slug: $slug, lang: $lngShort) @include(if: $includePlace) {\n    ...AggregatesListingsSEOLinks_place\n    ...AggregatesListingsFAQ_place\n    canonicalPlace {\n      slug\n      lang\n      id\n    }\n    index\n    indexRooms\n    id\n  }\n  aggregatorCustomPagesByPlace(placeSlug: $slug, offerType: $offerType, language: $lngShort) {\n    ...AggregatesListingsSEOLinks_popularSearches\n    id\n  }\n  country @include(if: $includeCountry) {\n    ...AggregatesListingsSEOLinks_place\n    ...AggregatesListingsFAQ_place\n    id\n  }\n}\n\nfragment Breadcrumbs_hierarchy on CMSPage {\n  template\n  link_title\n  custom_path\n  _meta {\n    uid\n  }\n}\n\nfragment CheckedFilters_filters on AggregatesListingFilters {\n  offerType_eq\n  places {\n    label\n    id\n  }\n  compositePropertyType_eq\n  livingSurface_lte\n  livingSurface_gte\n  landSurface_lte\n  landSurface_gte\n  hasBalcony_eq\n  hasGarden_eq\n  hasParking_eq\n  hasElevator_eq\n  hasView_eq\n  hasFireplace_eq\n  hasGarage_eq\n  isFurnished_eq\n  bookOnline_eq\n  isFsbo_eq\n  isChildFriendly_eq\n  isWheelchairAccessible_eq\n  isMinergieCertified_eq\n  isNewDevelopment_eq\n  salePrice_lte\n  salePrice_gte\n  grossRentMonthly_lte\n  grossRentMonthly_gte\n  salePricePerLivingSurface_gte\n  salePricePerLivingSurface_lte\n  agencyReference_contains\n  agencyNames\n  salePricePerLandSurface_lte\n  salePricePerLandSurface_gte\n  grossRentRoomMonthly_lte\n  grossRentRoomMonthly_gte\n  grossRentM2yearly_lte\n  grossRentM2yearly_gte\n  numberOfRooms_gte\n  numberOfRooms_lte\n  portal_in\n}\n\nfragment Layout_pageWithData on CMSPageWithData {\n  hierarchy {\n    ...Breadcrumbs_hierarchy\n  }\n  page {\n    template\n    canonical_url {\n      __typename\n      ... on CMS_ExternalLink {\n        url\n      }\n      ... on CMSPage {\n        _meta {\n          uid\n          lang\n        }\n      }\n    }\n    meta_robots\n    show_phone\n    _meta {\n      id\n      lang\n      alternateLanguages {\n        uid\n        lang\n        id\n      }\n    }\n  }\n}\n\nfragment Layout_root_3iqx2P on Query {\n  cms {\n    navigation(uid: \"main\", lang: $lang) {\n      nav_logo_link {\n        __typename\n        ... on CMSPage {\n          template\n          _meta {\n            uid\n            lang\n          }\n        }\n      }\n      phone_number\n      body {\n        __typename\n        ... on CMSNavigationBodyNavigation_item {\n          primary {\n            label\n            pathname\n            nav_link {\n              __typename\n              ... on CMSPage {\n                template\n                _meta {\n                  id\n                  uid\n                  lang\n                }\n              }\n            }\n          }\n          fields {\n            label\n            pathname\n            sub_nav_link {\n              __typename\n              ... on CMSPage {\n                template\n                _meta {\n                  uid\n                  lang\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    footerNavigation: navigation(uid: \"footer\", lang: $lang) {\n      phone_number\n    }\n  }\n}\n\nfragment TopFilters_page on CMSPage {\n  ...countrySwitcher_page\n}\n\nfragment TopFilters_root on Query {\n  aggregatesListings(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, filters: $filters) {\n    filters {\n      places {\n        slug\n        lang\n        label\n        id\n      }\n    }\n  }\n}\n\nfragment aggregatesListingAlertDialog_aggregatesListings on AggregatesListingConnectionConnection {\n  filters {\n    ...CheckedFilters_filters\n  }\n}\n\nfragment aggregatesListingDialogClient_aggregatesListings on AggregatesListingConnectionConnection {\n  ...aggregatesListingDialog_aggregatesListings\n}\n\nfragment aggregatesListingDialog_aggregatesListings on AggregatesListingConnectionConnection {\n  totalCount\n  filters {\n    places {\n      label\n      id\n    }\n  }\n  ...AggregatesListing_aggregatesListings\n}\n\nfragment countrySwitcher_page on CMSPage {\n  template\n  _meta {\n    uid\n    lang\n    alternateLanguages {\n      uid\n      lang\n    }\n  }\n}\n\nfragment useAggregatesListingsPlaceData_aggregatesListings on AggregatesListingConnectionConnection {\n  filters {\n    places {\n      slugEn: slug(lang: en)\n      type\n      label\n      inLabel\n      indexRooms\n      id\n    }\n  }\n}\n\nfragment useListingStructuredData_listing on AggregatesListing {\n  currency\n  images(first: 100) {\n    bucketName\n    fileName\n    id\n  }\n  grossRentMonthly\n  livingSurface\n  numberOfRooms\n  postcode\n  propertyMainType\n  lat\n  lng\n  propertyType\n  route\n  salePrice\n  streetNumber\n  subLocality\n  encodedId\n  offerType\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ec32e38f91e8110a1287422c4830dd61';

export default node;
